import { Component, Vue } from 'vue-property-decorator';
import App from './App.vue';
import VueCookies from 'vue-cookies';
import VueMoment from 'vue-moment';
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue';
import router from './router';
import store from './store';
import axios, { AxiosError, AxiosResponse } from 'axios';
import Vuelidate from 'vuelidate';

import './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './custom.scss';
import './assets/scss/fontawesome.scss';
import './assets/scss/regular.scss';
import './assets/scss/solid.scss';
import './assets/scss/brands.scss';

Component.registerHooks(['validations']);

Vue.use(VueMoment);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(VueCookies);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use((config: any) => {
    const token = localStorage.getItem('rbb:token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

axios.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    (error: AxiosError) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('rbb:token');
        }
        return error;
    },
);

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
